import React, { useState } from "react";
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { useEffect } from "react";
import axios from "axios"
import Checkout from "./Checkout";
import RegisterSocial from "./RegisterSocial";
import { Modal } from "react-bootstrap";
import ProfileSwitcher from "./ProfileSwitcher";




const Pricing = ({profile, rank }) => {
  const [interval, setInterval] = useState("annual"); // Toggle state

  const [photo, setPhoto] = useState(profile?.socials?.[profile?.selectedProfile]?.photo || "/images/default.png");
  const [username, setUsername] = useState(profile?.socials?.[profile?.selectedProfile]?.username || null);
  const [show, setShow] = useState(false);
  const [planName, setPlanName] = useState("");
  const [isAnnual, setIsAnnual] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingPlanChange, setPendingPlanChange] = useState(null);
  const [loading, setLoading] = useState(false);

  const [currentUrl, setCurrentUrl] = useState("");
  const [isHomePage, setIsHomePage] = useState(false);

  useEffect(() => {
    const url = window.location.href;
    setCurrentUrl(url);
    // Check if it's home page by seeing if path is / or /home
    setIsHomePage(window.location.pathname === "/" || window.location.pathname === "/home");
  }, []);

  // Show free trial button only on home page
  const showFreeTrial = isHomePage && !profile;

  
  const plans = [
	{
		name: "Pro Plan",
		url: "pro",
		price: { monthly: 69, annual: 41 },
		features: [
		  { icon: "fa-solid fa-bolt", feature: "Automatic Daily Delivery", description: "Followers are added to your account automatically every day - no action required." },
		  { icon: "fa-solid fa-user-group", feature: "3,000 - 4,000 Real Followers /mo", description: "Gain 3,000 - 4,000 real followers per month automatically without lifting a finger." },
		  { icon: "fa-solid fa-coins", feature: `${interval == "annual" ? "$600" : "$50"} Instant Boost Balance`, description: "Redeem your boost credit for instant Followers, Likes, Views, and Comments." },
		  { icon: "fa-solid fa-gift", feature: "2x Daily Bonuses", description: "Earn 2x daily bonuses to gain more credits" },
		  { icon: "fa-solid  fa-tag", feature: "Save 20% On Instant Boosts", description: "Save 20% on all instant boosts (Followers, Likes, Views, Comments)" },
		  { icon: "fa-solid  fa-pencil", feature: "AI Content Tools", description: "Unlimited Access to AI-powered caption generator, trend analyzer, post reviewer and content idea generator" },
		  { icon: "fa-solid  fa-user-check", feature: "Profile Tools", description: "Profile enhancement suggestions and analytics" },
		  { icon: "fab fa-instagram", feature: "Instagram Tools", description: "Anonymous story viewing and high quality post downloader" },
		],
		popular: true,
	  },
    {
      name: "Basic Plan",
	  url: "basic",
      price: { monthly: 49, annual: 29 }, // Separate pricing for monthly/annual
      features: [
		{ icon: "fa-solid fa-bolt", feature: "Automatic Daily Delivery", description: "Followers are added to your account automatically every day - no action required." },
		{ icon: "fa-solid fa-user-group", feature: "1,000 - 2,000 Real Followers /mo", description: "Gain 1,000 - 2,000 real followers per month automatically without lifting a finger." },
		{ icon: "fa-solid fa-coins", feature: `${interval == "annual" ? "$300" : "$25"} Boost Credits`, description: "Redeem your boost credit for instant Followers, Likes, Views, and Comments." },
		{ icon: "fa-solid fa-gift", feature: "Daily Bonuses", description: "Earn daily bonuses to gain more credits" },
		{ icon: "fa-solid fa-chart-line", feature: "Trending Videos & Songs", description: "Access a curated list of trending videos and songs across all platforms." },

		{icon: "", feature: ""},
		{icon: "", feature: ""},
		{icon: "", feature: ""},
		{icon: "", feature: ""},
		{icon: "", feature: ""}


		
      ],
      popular: false,
    }
  
 
  ];

  const prices = {
	"pro": {
		"monthly": "69",
		"annual": "492",
		"annual_monthly": "41"
	},
	"basic":{
		"monthly": "49",
		"annual": "348",
		"annual_monthly": "29"
	}
}


  const getProRata = () => {
    try {
      // Get current plan price
      var currentPrice = prices[rank?.planName][rank?.planInterval]
     
      // Calculate remaining time in days
      const remainingDays = Math.floor((new Date(rank?.nextChargeDate) - new Date()) / (1000 * 60 * 60 * 24));
      console.log(`Remaining days: ${remainingDays}`);
      
      const remainingValue = Math.floor(currentPrice * remainingDays / (rank?.planInterval === "annual" ? 365 : 30));
      return {remainingValue, remainingDays};
    } catch (error) {
      console.log(error)
      return 0;
    }
  }



  const [nextRenewalDate, setNextRenewalDate] = useState(null);

  useEffect(() => {
    if (rank?.nextChargeDate) {
      setNextRenewalDate(new Date(rank.nextChargeDate));
    }
  }, [rank?.nextChargeDate]);


  const changePlan = async (planName, interval) => {
    setPendingPlanChange({ planName, interval });
    setShowConfirmModal(true);
  };

  const confirmPlanChange = async () => {
    try {
		setLoading(true);
      const response = await axios.post("https://api.viralgpt.com/purchase/change-plan", {
        newPlan: pendingPlanChange.planName,
        newInterval: pendingPlanChange.interval
      }, {
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
        }
      });
      if (response.data.message) {
        alert(response.data.message);
        window.location.reload();
      } else {
        alert("Error upgrading subscription: " + response.data.error);
      }
    } catch (error) {
      alert(error.response.data.error);
    } finally {
		setLoading(false);
      setShowConfirmModal(false);
    }
  };


  const loadCheckout = (planName, isAnnual) => {
    setShow(true);
    setPlanName(planName);
    setIsAnnual(isAnnual);
  }





  return (
    <section id="pricing" className="">
	
      <div className="container mx-auto text-center">
        <span className="text-4xl text-instagram font-bold">Purchase a Plan</span>
		<br></br>
		<span className="text-gray-500">Supercharge your Instagram growth with AI-powered automation and real followers.</span><br></br>
        <div className="mt-2 bg-white border-instagram border-2 p-3 rounded-lg inline-block">
          <p className=" font-medium mb-0">
            <i className="fa-solid fa-wand-magic-sparkles me-2 text-instagram-2"></i>
            Purchase a plan to start gaining real followers automatically!
          </p>
        </div>

		<br></br><br></br>	
		<div className="flex flex-row items-center justify-center gap-2">
			{/*<img src={photo} alt="Upgrade" className="rounded-full" style={{ width: "30px", height: "30px" }}/>
			
			<span className="text-2xl text-gray-600 font-bold">{username}</span>*/}
			{username && (
				<ProfileSwitcher />
			)}
		</div>
   
        {/* Toggle Switch */}
        <div className="flex justify-center items-center mt-4">
			
		<div className="flex bg-gray-100 rounded-lg p-1">
			<button
			onClick={() => setInterval("annual")}
			className={`px-6 py-2 rounded-lg ${
				interval == "annual" ? "bg-white shadow font-bold text-black" : "text-gray-500"
			}`}
			>
			Annual
			
				<span className="ml-2 bg-green-100 text-green-600 text-sm px-2 py-1 rounded-lg">
				Save 50%
				</span>
			
			</button>
			<button
			onClick={() => setInterval("monthly")}
			className={`px-6 py-2 rounded-lg ${
				interval == "monthly" ? "bg-white shadow font-bold text-black" : "text-gray-500"
			}`}
			>
			Monthly
			</button>
		</div>
		</div>

        {/* Pricing Cards */}
        <div className="mx-auto max-w-screen-md grid grid-cols-1 md:grid-cols-2 gap-8 mt-12 justify-center text-center items-start">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`relative bg-white p-8 shadow-lg rounded-lg transform transition duration-300 ${
                plan.popular ? "border-3 border-purple-400" : ""
              }`}
            >
              {plan.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-instagram-2 text-white px-4 py-1 rounded-full">
                  Most Popular
                </div>
              )}

              <span className={`text-xl font-bold ${plan.name === "Basic Plan" ? "text-black" : "text-instagram-2"}`}>
                {plan.name}
              </span>
			  <br></br>
              <p className="mt-3" style={{ position: "relative", display: "inline-block" }}>
                <span
                  style={{
                    position: "absolute",
                    top: "0px", // Adjust the vertical alignment
                    left: "-15px", // Adjust the horizontal alignment
                    fontSize: "1.5rem", // Adjust to make the "$" smaller than the number
                  }}
                >
                  $
                </span>
                <span className="text-6xl font-bold">
                  {interval == "annual" ? plan.price.annual : plan.price.monthly}
                </span>
                <span className="text-3xl">/mo</span>
              </p>
			  <br></br>
			  <small className="text-gray-500">
			  {plan.name === "Pro Plan" 
                ? <span>The Pro Plan delivers <strong>100 real followers</strong> to your account every day automatically. Perfect for steady, hands-free growth.</span> 
                : <span>The Basic Plan adds <strong>33 real followers</strong> to your account daily with zero effort required. Perfect for steady, hands-free growth.</span>}
			  </small>

              <hr className="bg-instagram" />
			
              <ul className="text-left space-y-2 text-gray-700">
                {plan.features
                  .filter(feature => feature.feature) // Only include features with text
                  .map((feature, idx) => (
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip className="pe-4" id="button-tooltip-2">{feature.description}</Tooltip>}
                    >
                      {({ ref, ...triggerHandler }) => (
                        <li ref={ref} key={idx} {...triggerHandler} className="text-gray-700 flex items-center hover:bg-gray-100">
                          <i 
                            className={`${feature.icon} text-instagram h-5 w-10 mr-2`}
                          />
                          <span className={`${idx > 4 ? 'text-white text-instagram-2 font-bold' : 'text-dark'}`}>
                            {feature.feature} 
                          </span>
                        </li>
                      )}
                    </OverlayTrigger>
                  ))}
              </ul>
			  
	
				{/*<div> {rank?.status} {rank?.planName} {rank?.planInterval}  {plan.url} {interval == "annual" ? "annual" : "monthly"}</div>*/}
				

				{!username && profile && (
					<>
						<div onClick={() => setShow(true)} className="btn btn-primary bg-instagram w-full text-white">
							<i className="fa-solid fa-link me-2"></i>
							Link your Profile
						</div>
						<Modal show={show} onHide={() => setShow(false)} centered size="lg">
							<Modal.Header closeButton>
								<Modal.Title>Link Your Profile</Modal.Title>
							</Modal.Header>
							<Modal.Body>
								<RegisterSocial />
							</Modal.Body>
						</Modal>
					</>
				)}

				{ ((rank?.status != "active" && rank?.status != "scheduled") && profile && username) ? (
					<>
						<div onClick={() => loadCheckout(plan.url, interval == "annual")} className={`btn btn-primary ${plan.url === "pro" ? "bg-instagram" : "bg-black"} w-full`}>Purchase</div>
						<Checkout 
							show={show}
							onHide={() => setShow(false)}
							planName={planName}
							isAnnual={isAnnual}
							profile={profile}
						/>
					</>
					) : (
						
						<>
							<div className={`w-full ${!username && "d-none"} ${profile != undefined && "btn btn-primary bg-instagram"} ${rank?.planName == plan.url && rank?.planInterval == interval && "disabled"} ${rank?.scheduledPlan?.pending_plan == plan.url && rank?.scheduledPlan?.pending_interval == interval  && "disabled"}`}>
							{rank?.scheduledPlan?.pending_plan == plan.url && rank?.scheduledPlan?.pending_interval == interval  && "disabled" ? (
								<div><i class="fa-solid fa-clock"></i> Scheduled for {nextRenewalDate ? nextRenewalDate.toLocaleDateString() : "Unknown"}</div>
							) : rank?.planName == plan.url && rank?.planInterval == interval ? (
								<div><i class="fa-solid fa-check"></i> Current Plan</div>
							) : rank?.planName == plan.url && rank?.planInterval == "annual" && rank?.planInterval != interval ? (
								<div onClick={() => changePlan(plan.url, interval)}><i class="fa-solid fa-calendar-day"></i> Switch to monthly</div>
							) : rank?.planName == plan.url && rank?.planInterval == "monthly" && rank?.planInterval != interval ? (
								<div onClick={() => changePlan(plan.url, interval)}><i class="fa-solid fa-calendar-days"></i> Switch to annual</div>
							) : rank?.planName != plan.url && rank?.planName == "pro" ? (
								<div onClick={() => changePlan(plan.url, interval)}><i class="fa-solid fa-arrow-down"></i> Downgrade</div>
							) : rank?.planName != plan.url && rank?.planName == "basic" ? (
								<div onClick={() => changePlan(plan.url, interval)}><i class="fa-solid fa-arrow-up"></i> Upgrade</div>
							) : null}
							</div>
						</>
				)}
				

               {!profile && (
                <div className="w-full">
                  <a
                    href={`/register?purchase=${plan.url}&interval=${interval}`}
                    className={`block w-full text-center rounded mt-6 text-white px-6 py-2 rounded-full hover:bg-blue-700 transition ${
                      plan.popular ? "bg-instagram" : "bg-dark"
                    }`}
                  >
                    Purchase
                    
                    {rank?.planName == plan && rank?.status == "active" && (<div>Selected</div>)}
                  </a>
                </div>
               )}
            </div>
          ))}
        </div>

		  {!profile && (
			<div className="mt-12 text-center p-4">
				<div className="flex items-center justify-center gap-2 mb-2">
					<h2 className="text-2xl font-bold">7-Day Money Back Guarantee</h2>
				</div>
				<p className="text-gray-600 p-2">
					Try our service risk-free. If you're not completely satisfied, we'll refund your payment - no questions asked.
				</p>
                <div className="mt-4 bg-green-50 p-4 rounded-lg inline-block">
                  <p className="text-green-800 font-medium mb-0">
                    <i className="fa-solid fa-check-circle me-2"></i>
                    Zero effort required - we automatically add real followers to your account every day!
                  </p>
                </div>
			</div>
		  )}


      </div>

      {/* Confirmation Modal */}
      <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} className="rounded-lg">
        <Modal.Header closeButton className="bg-gradient-to-r from-instagram to-instagram-dark  border-0">
          <Modal.Title className="text-xl font-bold">
            <i className="fas fa-sync-alt mr-2 text-instagram"></i>
            Confirm Plan Change
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-6">
          <div className="bg-gradient-to-br from-blue-50 to-purple-50 p-6 rounded-xl shadow-sm border border-blue-100">
            <h4 className="text-lg font-medium text-gray-800 mb-4">Plan Change Details</h4>
            {profile && (
              <div className="flex items-center mb-4 bg-white p-4 rounded-xl shadow-sm border border-gray-100">
                <Image 
                  src={photo}
                  width={40}
                  height={40}
                  className="rounded-full mr-3"
                  alt="Profile"
                />
                <div>
                  <div className="font-medium text-gray-800">{username}</div>
                  <div className="text-sm text-gray-500">{profile?.socials?.[profile?.selectedProfile]?.platform?.charAt(0).toUpperCase() + profile?.socials?.[profile?.selectedProfile]?.platform?.slice(1)} Account</div>
                </div>
              </div>
            )}
            <div className="space-y-4">
              <div className="flex items-center">
                <div className="w-32 text-gray-500">Current Plan:</div>
                <div className="font-semibold text-gray-700">
                  {rank?.planName?.charAt(0).toUpperCase() + rank?.planName?.slice(1)} Plan
                </div>
              </div>
              <div className="flex items-center">
                <div className="w-32 text-gray-500">New Plan:</div>
                <div className="font-semibold">
                  {pendingPlanChange?.planName?.charAt(0).toUpperCase() + pendingPlanChange?.planName?.slice(1)} Plan
                </div>
              </div>
              <div className="flex items-center">
                <div className="w-32 text-gray-500">Billing Interval:</div>
                <div className="font-semibold ">
                  {pendingPlanChange?.interval?.charAt(0).toUpperCase() + pendingPlanChange?.interval?.slice(1)}
                </div>
              </div>
              <div className="flex items-center">
                <div className="w-32 text-gray-500">Price:</div>
                <div className="font-semibold ">
                  ${plans.find(p => p.url === pendingPlanChange?.planName)?.price[pendingPlanChange?.interval]}/month
                </div>
              </div>
            </div>
          </div>

          <div className="mt-6 bg-gradient-to-r from-amber-50 to-yellow-50 p-6 rounded-xl border border-amber-200">
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 pt-1">
                <i className="fas fa-lightbulb text-amber-500 text-xl"></i>
              </div>
              <div>
                <h5 className="text-amber-900 font-medium mb-3">Billing Information</h5>
                <p className="text-amber-800 text-sm leading-relaxed m-0">
                  Your new plan will be activated immediately. We'll add a prorated refund of <span className="font-semibold">${getProRata().remainingValue}</span> to your account based on your remaining subscription time ({getProRata().remainingDays} days).
                </p>
              </div>
            </div>
          </div>

          <div className="mt-4 flex items-center bg-blue-50 p-4 rounded-xl border border-blue-100">
            <i className="fas fa-info-circle text-blue-500 mr-4"></i>
            <p className="text-blue-800 text-sm m-0">Your billing cycle will reset to today, with future charges occurring on this date.</p>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button 
            variant="light" 
            onClick={() => setShowConfirmModal(false)}
            className="px-6 py-2 rounded-full hover:bg-gray-100 transition-colors"
          >
            <i className="fas fa-times mr-2"></i>
            Cancel
          </Button>
          <Button 
            variant="instagram"
            onClick={confirmPlanChange}
            disabled={loading}
            className={`bg-instagram text-white px-6 py-2 rounded-full hover:bg-instagram-dark ml-3 transition-colors ${loading ? 'disabled' : ''}`}
          >
            <i className="fas fa-check mr-2"></i>
            Confirm Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </section>
  );
};

export default Pricing;
